export const logError = (error) => {
    window.Sentry?.captureException(error);
    window.newrelic?.noticeError(error);
}
